import { createSelector } from 'reselect'

import { RootState } from 'state/types'

import { InsuranceType } from './types'

export const getInsuranceTypes = createSelector(
  [ (state: RootState): InsuranceType[] | undefined => state.insuranceTypes.data || undefined ],
  insuranceTypes => insuranceTypes,
)

export const getIsInsuranceTypesCached = createSelector(
  [ (state: RootState): boolean => (state.insuranceTypes.cached && true) || false ],
  isInsuranceTypesCached => isInsuranceTypesCached,
)

export const getIsInsuranceTypesLoading = createSelector(
  [ (state: RootState): boolean => (state.insuranceTypes.loading && true) || false ],
  isInsuranceTypesLoading => isInsuranceTypesLoading,
)

export const getInsuranceType = createSelector(
  [
    (state: RootState, slug: string): InsuranceType | undefined => {
      const insuranceTypes = getInsuranceTypes(state)

      return (
        (insuranceTypes &&
          insuranceTypes.find(
            insuranceType => insuranceType.slug === slug,
          )) ||
        undefined
      )
    },
  ],
  insuranceType => insuranceType,
)
